export default [
  {
    text: 'Tell me about...',
    value: 'Tell me about',
  },
  {
    text: 'Book Appointment',
    value: 'Book an appointment',
  },
  {
    text: 'Place an order',
    value: 'Place an order',
  },
  {
    text: 'Tell me a Joke',
    value: 'Tell me a joke',
  },
  {
    text: 'Get an inspirational quote',
    value: 'share a daily quote',
  },
  {
    text: 'Today\'s weather',
    value: 'Today\'s weather',
  },
  {
    text: 'Help',
    value: 'Help',
  },

];



// WEBPACK FOOTER //
// ./src/config/SuggestionList.js